import { stringToNumber } from '@23degrees/shared-code/data/utilities';
import { formatField } from './formatField';
import { DataRow } from '@23degrees/shared-code/models';

interface DeltaInsertOp {
  insert: any;
  attributes: any;
}

export class DynamicLink {
  deltaOp: DeltaInsertOp;

  hasLabelField: boolean;
  labelField: string;
  urlField: string;
  label: string;
  target: string;
  title: string;

  protected constructor(deltaOp: DeltaInsertOp) {
    this.deltaOp = deltaOp;
    this.hasLabelField = Boolean(Number.parseInt(deltaOp.insert?.value?.hasLabelField));
    this.labelField = deltaOp.insert?.value?.labelField;
    this.urlField = deltaOp.insert?.value?.urlField;
    this.label = deltaOp.insert?.value?.label;
    this.target = deltaOp.insert?.value?.target ?? '_blank';
    this.title = deltaOp.insert?.value?.title;
  }

  static create = (deltaOp: DeltaInsertOp) => {
    return new DynamicLink(deltaOp);
  };

  public resolveFields = (
    dataContext: DataRow,
    fallbackStr = 'No data available',
    content?: any,
    customFormat: Record<string, string | number> | null = null,
  ): string => {
    let inlineStr = '';

    if (!this.urlField || !dataContext || dataContext[this.urlField] === undefined || dataContext[this.urlField] === null) {
      inlineStr = fallbackStr; // content?.typeSpecific.noDataMessages?.inline;
    }

    const title: string = this.hasLabelField ? dataContext[this.labelField] : this.title;
    const url: string = dataContext[this.urlField];

    inlineStr = `<a href="${url}" target="${this.target}">${title}</a>`;
    return inlineStr;
  };
}
